"use client";

import type { PropsWithChildren } from "react";

import type { ColoredSectionStoryblok } from "@/types/blok-types";

import useColoredSection from "./useColoredSection";

const ClientColorTrigger = ({
  blok,
  children,
}: PropsWithChildren<{
  blok: ColoredSectionStoryblok;
}>): React.JSX.Element => {
  const { ref } = useColoredSection(blok.color);

  return (
    <div className="background__change__trigger" ref={ref}>
      {children}
    </div>
  );
};
export default ClientColorTrigger;
